export const Info = () => (
  <path
    d='M11.8894 9.42857H13.6037L11.7179 18H10.0037L11.8894 9.42857ZM13.3294 6C13.1598 6 12.9941 6.05027 12.8532 6.14445C12.7122 6.23864 12.6024 6.37251 12.5375 6.52913C12.4726 6.68575 12.4556 6.85809 12.4887 7.02436C12.5218 7.19063 12.6034 7.34336 12.7233 7.46323C12.8432 7.58311 12.9959 7.66474 13.1622 7.69782C13.3284 7.73089 13.5008 7.71391 13.6574 7.64904C13.814 7.58416 13.9479 7.4743 14.0421 7.33335C14.1362 7.19239 14.1865 7.02667 14.1865 6.85714C14.1865 6.62981 14.0962 6.4118 13.9355 6.25105C13.7747 6.09031 13.5567 6 13.3294 6Z'
    fill='currentColor'
  />
)
